module.exports = __webpack_public_path__ + "img/tutorial20200129.660b53af.gif";